import { firstToLowerCase } from '../../common/utils/helper';
import { TechnicalAnalysis } from './indicator-base';
/**
 * `EmaIndicator` module is used to render EMA indicator.
 */
export class EmaIndicator extends TechnicalAnalysis {
    /**
     * Defines the predictions based on EMA approach
     *
     * @private
     */
    initDataSource(indicator, chart) {
        const field = firstToLowerCase(indicator.field);
        const xField = 'x';
        const emaPoints = [];
        const signalSeries = indicator.targetSeries[0];
        //prepare data
        const validData = indicator.points;
        if (validData && validData.length && validData.length >= indicator.period) {
            //find initial average
            let sum = 0;
            let average = 0;
            //smoothing factor
            const k = (2 / (indicator.period + 1));
            for (let i = 0; i < indicator.period; i++) {
                sum += validData[i][field];
            }
            average = sum / indicator.period;
            emaPoints.push(this.getDataPoint(validData[indicator.period - 1][xField], average, validData[indicator.period - 1], signalSeries, emaPoints.length));
            let index = indicator.period;
            while (index < validData.length) {
                //previous average
                const prevAverage = emaPoints[index - indicator.period][signalSeries.yName];
                const yValue = (validData[index][field] - prevAverage) * k + prevAverage;
                emaPoints.push(this.getDataPoint(validData[index][xField], yValue, validData[index], signalSeries, emaPoints.length));
                index++;
            }
        }
        this.setSeriesRange(emaPoints, indicator);
    }
    /**
     * To destroy the EMA Indicator
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the EMA Indicator
         */
    }
    /**
     * Get module name.
     */
    getModuleName() {
        /**
         * Returns the module name of the series
         */
        return 'EmaIndicator';
    }
}
